module.exports = __webpack_public_path__ + "static/img/dfzh.bbd1a1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dfzh.png
// module id = ZEks
// module chunks = 0